import ExamResults from './ExamResults';

export default ExamResults;
